<template>
    <div class="animated fadeIn">
    
        <ChangeControlUnitComponent v-if="!$store.state.currentUnit.id" />
        <ChangeControlHeaderComponent v-if="$store.state.currentUnit.id" />

        {{
        /*
          this.selectedChangeControlMovement 
        */
        }}

        <b-row v-if="$store.state.currentUnit.id">
            <b-col md="12">
                <b-card header="DENOMINAÇÕES">
                    <b-row>
                        <b-col sm="5">
                            <h4 id="traffic" class="card-title mb-0"></h4>
                            <div class="small text-muted">&nbsp;</div>
                            <div class="small text-muted">&nbsp;</div>
                        </b-col>
                        <b-col sm="7" class="d-none d-md-block">
                            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                                <b-button type="button" @click="getDenominations()" variant="primary" class="float-right"><i class="icon-refresh"></i></b-button>
                                <span style="width:10px"></span>
                                <b-button type="button" @click="$bvModal.show('help')" variant="primary" class="float-right"><i class="icon-info"></i></b-button>
                            </b-button-toolbar>
                            
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="12">
                            <b-row>
                                <b-col sm="6" md="4" lg="3" xl="2"  v-for="item in data_denomination" :key="item.id">
                                    <Callout :variant="item.variant">
                                      <center>
                                        <strong class="h6 text-muted">R$ {{ numberFormat(item.value) }}</strong><br>
                                        <small class="text-muted"><img :src="item.image" width="80px" :style="{ width: item.imageWidth +'px' }"></small>
                                        <br>&nbsp;
                                        <br>
                                        <b-form-group>
                                            <b-form-input type="text" :id="item.varname" :name="item.varname" v-model="item.quantity" v-on:keyup="changeQuantity" placeholder="" v-on:keypress="numbersOnly" style="width: 105px"> </b-form-input>  <small class="text-muted"></small>
                                        </b-form-group>
                                        <small class="text-muted">R$ </small><strong class="h5">{{ numberFormat(item.quantity * item.value) }}</strong><br>
                                      </center>
                                    </Callout>
                                </b-col>
                            </b-row>
                            
                        </b-col>
                    </b-row>



                    <div slot="footer">
                        <b-row class="text-center">
                        <b-col class="mb-sm-2 mb-0">
                            <div class="text-muted">Total em Moedas</div>
                            <strong><small class="text-muted">R$</small> {{ numberFormat(total_coin) }}</strong>
                            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="success" :value="total_coin * 100 / total"></b-progress>
                        </b-col>
                        <b-col class="mb-sm-2 mb-0 d-md-down-none">
                            <div class="text-muted">Total em Cédulas</div>
                            <strong><small class="text-muted">R$</small> {{ numberFormat(total_note) }}</strong>
                            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="info" :value="total_note * 100 / total"></b-progress>
                        </b-col>
                        <b-col class="mb-sm-2 mb-0">
                            <div class="text-muted">TOTAL</div>
                            <strong><small class="text-muted">R$</small> {{ numberFormat(total) }}</strong>
                            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="warning" :value="total * 100 / total"></b-progress>
                        </b-col>        
                        </b-row>
                    </div>

                       
                    <b-row>
                        <b-col sm="6" md="4" lg="4">
                                    <Callout variant="danger">
                                        <strong class="h4">CONFIRMAÇÃO OPERADOR</strong><br>
                                        <b-form-group>
                                            <b-form-input type="text" id="operator_code" placeholder="" v-model="selectedOperator.name" readonly></b-form-input>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-form-input type="text" id="operator_name" placeholder="USUÁRIO OPERADOR" v-model="selectedOperator.code" @blur="getOperator()"></b-form-input>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-form-input type="password" id="operator_password" placeholder="SENHA" v-model="selectedOperator.password" v-if="!selectedChangeControlMovement.supervisorDate"></b-form-input>
                                            <b-form-input type="text" id="operator_date" placeholder="" v-model="selectedChangeControlMovement.supervisorDate" readonly v-if="selectedChangeControlMovement.supervisorDate"></b-form-input>
                                        </b-form-group>
                                    </Callout>
                                </b-col>

                                <b-col sm="6" md="4" lg="4">
                                    <Callout variant="primary">
                                        <strong class="h4">AUTORIZAÇÃO SUPERVISOR</strong><br>
                                        <b-form-group>
                                            <b-form-input type="text" id="supervisor_code" placeholder="" v-model="selectedSupervisor.name" readonly></b-form-input>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-form-input type="text" id="supervisor_name" placeholder="USUÁRIO SUPERVISOR" v-model="selectedSupervisor.code" @blur="getSupervisor()"></b-form-input>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-form-input type="password" id="supervisor_password" placeholder="SENHA" v-model="selectedSupervisor.password"></b-form-input>
                                        </b-form-group>
                                    </Callout>
                                </b-col>

                                <b-col sm="6" md="4" lg="4">
                                    <Callout variant="success">
                                        <strong class="h4">TOTAL</strong><br>
                                        <b-form-group>
                                            <b-form-input type="text" id="total" placeholder="" :value="numberFormat(total)" readonly></b-form-input>
                                        </b-form-group>
                                         <b-form-group>
                                            Total a ser retornado:
                                            <b-form-input type="text" id="total_return" placeholder="" :value="numberFormat(selectedChangeControlMovement.total)" readonly></b-form-input>
                                        </b-form-group>
                                    </Callout>
                                </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="5">
                        <h4 id="traffic" class="card-title mb-0">&nbsp;</h4>
                        <div class="small text-muted">&nbsp;</div>
                        <div class="small text-muted">&nbsp;</div>
                        </b-col>
                        <b-col sm="7" class="d-none d-md-block">
                        <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                            <b-button type="button" @click="selectMovementDenominations()" variant="success" class="float-right">Selecionar Denominações da Retirada</b-button>
                            <span style="width: 10px"></span>
                            <b-button type="button" @click="confirmWithdraw()" variant="danger" class="float-right">Confirmar Retorno</b-button>

                           
                        </b-button-toolbar>
                        
                        </b-col>
                    </b-row>

                    
                </b-card>
    
               

            </b-col>
        </b-row>

        <b-row v-if="$store.state.currentUnit.id">
            <b-col md="12">
                <b-card header="ÚLTIMAS RETIRADAS">
                    <b-row>
                        <b-col sm="5">
                            <h4 id="traffic" class="card-title mb-0"></h4>
                            <div class="small text-muted">&nbsp;</div>
                            <div class="small text-muted">&nbsp;</div>
                        </b-col>
                        <b-col sm="7" class="d-none d-md-block">
                            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                                <b-button type="button" @click="getWaitingReturn()" variant="primary" class="float-right"><i class="icon-refresh"></i></b-button>
                                <span style="width:10px"></span>
                                <b-button type="button" @click="$bvModal.show('help-template')" variant="primary" class="float-right"><i class="icon-info"></i></b-button>
                            </b-button-toolbar>
                            
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="6" lg="3" v-for="item in data_change_outgoing" :key="item.id">
                        <ChangeControlItemComponent :controlitem="item" :controltype="1" />
                        </b-col>
                    </b-row>

                    <div slot="footer">
                    <b-row class="text-center">
                    </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>

        <div>
        <b-modal id="help" title="Ajuda" ok-only size="lg"
        ok-title="Fechar">
            <h3>Controle de Troco - Retirada / Saída de Gaveta</h3>
            <h4>Denominações</h4>
            <p class="my-4">
            <ol>
                <li>Selecione a quantidade de denominações (moedas e cédulas) a serem entregues.<br><span class="small text-muted">Obs: Os totalizadores serão exibidos.</span></li>
                <li>Caso a quantidade de denominações selecionada seja sempre utilizada, é possível gravá-la como um <i>Modelo de Retirada / Pacote</i>. Clique em <i>Salvar Como Modelo</i> e entre com um nome. Para utilizar o modelo, clique no menu do modelo desejado e em <i>Selecionar modelo</i>.</li>
                <li>Entregue as denominação ao Operador. Digite o nome do usuário e a senha em <i>Confirmação Operador</i> após a conferência.</li>
                <li>Digite o nome do usuário e a senha em <i>Autorização Supervisor</i> para continuar o processo de retirada.</li>
                <li>Clique em <i>Confirmar Retorno</i> para liberar os valores.</li>
            </ol>
            </p>
            <h4>Modelos de Retirada / Pacotes</h4>
            <p class="my-4">
            <ol>
                <li>Para utilizar um modelo clique no menu correspondente e selecione <i>Selecionar modelo</i>. As quantidade de denominações serão ajustadas conforme disponibilidade no caixa.</li>
                <li>Para alterar o nome do modelo clique no menu correspondente e selecione <i>Alterar nome do modelo</i>.</li>
                <li>Para excluir um modelo clique no menu correspondente e selecione <i>Excluir</i>.</li>   
            </ol>
            </p>
        </b-modal>
        </div>


    </div>

</template>

<script>
import Vue from 'vue'

import axios from "axios";
import { Callout } from '@coreui/vue'
import ChangeControlUnitComponent from '../../components/ChangeControlUnitComponent'
import ChangeControlHeaderComponent from '../../components/ChangeControlHeaderComponent'
import ChangeControlItemComponent from '../../components/ChangeControlItemComponent'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

 VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)


export default {
    name: 'dashboard',
    components: {
        Callout,
        ChangeControlUnitComponent,
        ChangeControlHeaderComponent,
        ChangeControlItemComponent,
    },
    data: function() {
        return {
            errorMessage: "",
            selectedOperator: { code: null, name: null, supervisor: false},
            selectedSupervisor: { code: null, name: null, supervisor: true},

            confirmDelete: '',

            total: 0,
            total_coin: 0,
            total_note: 0,
            
            currentChangeControl: {},
            selectedChangeControlMovement: {},

            data_change_outgoing: [
                /*
                { id: 1, operatorCode: 123456, operatorName: 'Alexandre Kenji Takamura', startDate: '2022-06-16 16:27:12', total: 200, class: 'bg-primary' },
                { id: 2, operatorCode: 234567, operatorName: 'José Emílio do Prado', startDate: '2022-06-16 13:41:12', total: 250, class: 'bg-success' },
                */
            ],

            data_denomination: [
                /*
                { id: 0, varname: 'denomination_0', value: 0.01, quantity: 0, totalQuantity: 0, color: 'bg-indigo', image: 'img/currency/real_001.png', imageWidth: 80, type: 1, variant: 'warning' },
                { id: 1, varname: 'denomination_1', value: 0.05, quantity: 200, totalQuantity: 600, color: 'bg-indigo', image: 'img/currency/real_005.png', imageWidth: 80, type: 1, variant: 'warning'  },
                { id: 2, varname: 'denomination_2', value: 0.10, quantity: 250, totalQuantity: 1000, color: 'bg-indigo', image: 'img/currency/real_010.png', imageWidth: 80, type: 1, variant: 'warning'},
                { id: 3, varname: 'denomination_3', value: 0.25, quantity: 100, totalQuantity: 500, color: 'bg-indigo', image: 'img/currency/real_025.png', imageWidth: 80, type: 1, variant: 'warning'  },
                { id: 4, varname: 'denomination_4', value: 0.50, quantity: 100, totalQuantity: 1000, color: 'bg-indigo', image: 'img/currency/real_050.png', imageWidth: 80, type: 1, variant: 'warning'  },
                { id: 5, varname: 'denomination_5', value: 1, quantity: 200, totalQuantity: 300, color: 'bg-indigo', image: 'img/currency/real_1.png', imageWidth: 80, type: 1, variant: 'warning'  },
                { id: 7, varname: 'denomination_7', value: 2, quantity: 50, totalQuantity: 300, color: 'bg-indigo', image: 'img/currency/real_2.png', imageWidth: 130, type: 2, variant: 'success'},
                { id: 8, varname: 'denomination_8', value: 5, quantity: 50, totalQuantity: 300, color: 'bg-indigo', image: 'img/currency/real_5.png', imageWidth: 130, type: 2, variant: 'success' },
                { id: 9, varname: 'denomination_9', value: 10, quantity: 100, totalQuantity: 100, color: 'bg-indigo', image: 'img/currency/real_10.png', imageWidth: 130, type: 2, variant: 'success'  },
                { id: 10, varname: 'denomination_10', value: 20, quantity: 80, totalQuantity: 50, color: 'bg-indigo', image: 'img/currency/real_20.png', imageWidth: 130, type: 2, variant: 'success'  },
                { id: 11, varname: 'denomination_11', value: 50, quantity: 10, totalQuantity: 30, color: 'bg-indigo', image: 'img/currency/real_50.png', imageWidth: 130, type: 2, variant: 'success' },
                { id: 12, varname: 'denomination_12', value: 100, quantity: 0, totalQuantity: 5, color: 'bg-indigo', image: 'img/currency/real_100.png', imageWidth: 130, type: 2, variant: 'success'  },
                */
            ]
        }
    },
    computed: {
        returnMovementId() {
            return this.$route.query.movement_id;
        },
        currentUserId() {
            return this.$store.state.currentUser.id;
        },
        currentUnitId() {
            return this.$store.state.currentUnit.id;
        }
    },
    watch: {
        returnMovementId(newValue, oldValue) {
            console.log("Alterado valor do control de troco: " + newValue)
            this.getMovement(newValue)


        },
        currentUnitId(newId, oldId) {
            //console.log("Unit changed: " + oldId + " - " + newId)
            this.getWaitingReturn()
            this.getDenominations()
        },
        currentUserId(newId, oldId) {
            //console.log("Operator changed: " + oldId + " - " + newId)
            //this.selectedSupervisor.name = this.$store.state.currentUser.name;
            //this.selectedSupervisor.code = this.$store.state.currentUser.code;
        },
    },
    methods: {
        changeQuantity() {

          var notes = 0;
          var coins = 0;
          this.data_denomination.forEach(function(item) {
            if(item.type == 1)
               coins += item.quantity * item.value
            else
               notes += item.quantity * item.value
          })
          this.total_coin = coins
          this.total_note = notes
          this.total = this.total_coin + this.total_note          
        },

        async checkPassword(userCode, password) {
        
            await axios.get(
                this.$store.state.ws_url + "/sgap/operator?code=" + userCode + "&password=" + password
            ).then(() => {
                return resp;
            }).catch(()=> {
                return 0;
            });

            return resp;
        },

        async getMovement(movementId) {
            var s = this
            await axios.get(
                this.$store.state.ws_url + "/changecontrol/movement/" + movementId
            ).then(function(resp) {
                s.selectedChangeControlMovement = resp.data            

                s.selectedSupervisor.name = s.selectedChangeControlMovement.supervisorName;
                s.selectedSupervisor.code = s.selectedChangeControlMovement.supervisorCode;

                s.selectedOperator.name = s.selectedChangeControlMovement.operatorName;
                s.selectedOperator.code = s.selectedChangeControlMovement.operatorCode;
            }).catch(function(error) {
                console.log(error)
            })
        },

        async getOperator() {
            var s = this
            
            if(this.selectedOperator.code) {
                await axios.get(
                    this.$store.state.ws_url + "/sgap/operator?code=" + this.selectedOperator.code
                ).then(function(resp) {
                    s.selectedOperator = resp.data
                }).catch(function(error) {
                    console.log(error)
                })
            
            }
            else {
                this.selectedOperator = { code: null, name: null, supervisor: true}    
            }
            
        },

        async getSupervisor() {
            var s = this
           
            if(this.selectedSupervisor.code) {
                await axios.get(
                    this.$store.state.ws_url + "/sgap/operator?code=" + this.selectedSupervisor.code
                ).then(function(resp) {
                    s.selectedSupervisor = resp.data
                }).catch(function(error) {
                    console.log(error)
                })
                
            }
            else {
                this.selectedSupervisor = { code: null, name: null, supervisor: true}
            }
          
        },

        async saveMovement() {
            try {
                var s = this
                var movement = {}
                var movementDenominations = new Array;

                movement.type = 4   // Fluxo de Retorno
                console.log(this.currentChangeControl)
                movement.changeControlId = this.currentChangeControl.id
                movement.supervisorCode = this.selectedSupervisor.code
                movement.supervisorPwd = this.selectedSupervisor.password

                movement.operatorCode = this.selectedOperator.code
                movement.operatorPwd = this.selectedOperator.password

                
                this.data_denomination.forEach( den => {
                    if(den.quantity > 0) {
                        var denom = { quantity: den.quantity, denomination: { id: den.id }  }
                        movementDenominations.push(denom)
                    }
                })
                movement.denominations = movementDenominations

                console.log(movement)

                //console.log(this.$store.state.ws_url + "/changecontrol/movement?typeCode=4&status=4&originId=" + this.$store.state.currentUnit.originId)
                    
                await axios.post(
                    this.$store.state.ws_url + "/changecontrol/movement",
                    movement
                ).then(function(resp) {

                }).catch(function(error) {
                    console.log(error)
                })
                
                this.getWaitingReturn()
                
            } catch (e) {
                console.log(e)                 
            }  
        },

        async getDenominations() {
            try {
                if(this.$store.state.currentUser.code && this.$store.state.currentUnit.originId) {
                    //console.log(this.$store.state.ws_url + "/changecontrol/movement?typeCode=4&status=4&originId=" + this.$store.state.currentUnit.originId)
                    const denominationsResponse = await axios.get(
                        this.$store.state.ws_url + "/changecontrol/denominations?originId=" + this.$store.state.currentUnit.originId + "&operatorCode=" + this.$store.state.currentUser.code
                    );
                    this.data_denomination = denominationsResponse.data.controlDenominations
                    this.currentChangeControl = denominationsResponse.data

                }
                else {
                     this.data_denomination = []
                }
                this.changeQuantity();
            } catch (e) {
                console.log(e)                 
            }  
        },

        async getWaitingReturn() {
            try {
                if(this.$store.state.currentUnit.originId) {
                    //console.log(this.$store.state.ws_url + "/changecontrol/movement?typeCode=4&status=4&originId=" + this.$store.state.currentUnit.originId)
                    const waitingReturnResponse = await axios.get(
                        this.$store.state.ws_url + "/changecontrol/movement?typeCode=4&status=4&originId=" + this.$store.state.currentUnit.originId
                    );
                    this.data_change_outgoing = waitingReturnResponse.data
                    //console.log(waitingReturnResponse.data)
                }
                else {
                     this.data_change_outgoing = []
                }
            } catch (e) {
                console.log(e)                 
            }  
        },

        numberFormat(x) {
            return parseFloat(x).toFixed(2).toString().replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        variant(value) {
            let $variant
            if (value <= 25) {
                $variant = 'info'
            } else if (value > 25 && value <= 50) {
                $variant = 'success'
            } else if (value > 50 && value <= 75) {
                $variant = 'warning'
            } else if (value > 75 && value <= 100) {
                $variant = 'danger'
            }
            return $variant
        },
        flag(value) {
            return 'flag-icon flag-icon-' + value
        },
        confirmWithdraw() {
            this.errorMessage = ""
            
            if(this.total == null || this.total <= 0) {
                 this.errorMessage = "Nenhuma denominação selecionada."
            }
            else
            if(this.total != this.selectedChangeControlMovement.total) {
                this.errorMessage = "Necessário retornar o mesmo total da retirada: R$" + this.numberFormat(this.selectedChangeControlMovement.total) + "."
            }
            else
            if((this.selectedOperator.name == null || this.selectedOperator.name.trim().length <= 0) && (this.selectedSupervisor.name == null || this.selectedSupervisor.name.trim().length <= 0)) {
                this.errorMessage = "Necessário confirmação do Operador e autorização do Supervisor."
            }
            else 
            if(this.selectedSupervisor.name == null || this.selectedSupervisor.name.trim().length <= 0) {
                this.errorMessage = "Necessário autorização do Supervisor."    
            }
            else
            if(this.selectedOperator.name == null || this.selectedOperator.name.trim().length <= 0) {
                this.errorMessage = "Necessário confirmação do Operador."
            }
            else
            if(this.selectedOperator.name == this.selectedSupervisor.name)
            {
                this.errorMessage = "Usuário Operador deve ser diferente do usuário Supervisor."
            }
            else
            if(this.selectedOperator.password == null || this.selectedOperator.password.trim().length <= 0 || this.selectedSupervisor.password == null || this.selectedSupervisor.password.trim().length <= 0) {
                this.errorMessage = "Favor preencher as senhas.";
            }                
            

            if( this.errorMessage.trim() != "") {
                //this.messageGeneric("Confirmar Saída", this.errorMessage)
                this.showErrorMsg({title: "Confirmar Retorno", message: this.errorMessage })
            }
            else {
                this.saveMovement()
                this.showInfoMsg({title: "Nova Retirada", message: "Criado nova retirada" })
            }    
            
        },
        numbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        messageGeneric(label, message) {
            this.$bvModal.msgBoxOk(message, {
            title: label,
            okTitle: 'OK',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
                return true
            })
            .catch(err => {
                return false
            })
        },
        // Seleciona as denominações utilizadas na retirada
        selectMovementDenominations() {
            if(this.selectedChangeControlMovement.denominations!=null) {
                this.data_denomination.forEach( den => {
                    var template_denominations = this.selectedChangeControlMovement.denominations.find( x => x.denomination.id === den.id);
                    if(template_denominations != null) {
                        den.quantity = template_denominations.quantity
                    }
                    else {
                        den.quantity = 0
                    }
                })
                this.changeQuantity()
                this.showSuccessMsg({title: "Denominações", message: "Selecionado denominações da retirada" })
            }
            else {
                this.messageGeneric("Modelo", "Sem denominação.")
            }
        },
    },
    mounted: function(){
        this.changeQuantity()
        this.getWaitingReturn()
        this.getDenominations()
        this.getMovement(this.returnMovementId)
        
    },
    notifications: {
        showSuccessMsg: {
        type: VueNotifications.types.success,
        title: 'Hello there',
        message: 'That\'s the success!'
        },
        showInfoMsg: {
        type: VueNotifications.types.info,
        title: 'Hey you',
        message: 'Here is some info for you'
        },
        showWarnMsg: {
        type: VueNotifications.types.warn,
        title: 'Wow, man',
        message: 'That\'s the kind of warning'
        },
        showErrorMsg: {
        type: VueNotifications.types.error,
        title: 'Erro',
        message: ""
        }
    }
}
</script>


<style>
</style>
